/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconH5 = createReactComponent("outline", "h-5", "IconH5", [["path", { "d": "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4", "key": "svg-0" }], ["path", { "d": "M4 6v12", "key": "svg-1" }], ["path", { "d": "M12 6v12", "key": "svg-2" }], ["path", { "d": "M11 18h2", "key": "svg-3" }], ["path", { "d": "M3 18h2", "key": "svg-4" }], ["path", { "d": "M4 12h8", "key": "svg-5" }], ["path", { "d": "M3 6h2", "key": "svg-6" }], ["path", { "d": "M11 6h2", "key": "svg-7" }]]);

export { IconH5 as default };
//# sourceMappingURL=IconH5.mjs.map
